var React = require('react');

function CurrencyPound12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0C7.59768 0 8.90366 1.24892 8.99491 2.82373L9 3H7C7 2.44772 6.55228 2 6 2C5.48716 2 5.06449 2.38604 5.00673 2.88338L5 3L5.00508 3.29096L5.02054 3.54971C5.03504 3.72982 5.05864 3.93233 5.09561 4.20007L5.214 5H7V7L5.46449 7.00079C5.48871 7.33237 5.5 7.65367 5.5 8C5.5 8.74183 5.32374 9.4209 5.02451 10.0006L9 10V12H2V10C2.69772 10 3.5 9.19772 3.5 8C3.5 7.65818 3.48688 7.34138 3.45786 7.0005L2 7V5H3.191L3.15762 4.77679C3.0522 4.05935 3.01315 3.69257 3.00296 3.26921L3 3C3 1.34315 4.34315 0 6 0Z","fill":"currentColor"}));
}

CurrencyPound12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CurrencyPound12;

CurrencyPound12.default = CurrencyPound12;
